import merge from "lodash.merge";
import { useFieldArray, useFormContext } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import PrincipalItem from "./PrincipalItem";

export const getPrincipalModel = () => ({
  name: "",
  notes: "",
  personal_net_worth: "",
  position: "",
  share_of_corporation: "",
  net_worth_document_filename: null,
});

const Principals = ({ partnerIndex, partnerId }) => {
  const form = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: `partners[${partnerIndex}].principals`,
  });

  const addPrincipal = () => {
    append({
      key: uuidv4(),
      ...merge(getPrincipalModel(), { partner_id: partnerId }),
    });
  };

  return (
    <div className={"border-gray mt-4"}>
      {fields.map((item, index) => (
        <PrincipalItem
          key={item.id || item.key}
          index={index}
          partnerIndex={partnerIndex}
          onDelete={() => remove(index)}
        />
      ))}
      <div
        className={"fw-bold text-primary mb-3 px-4 d-inline-block"}
        role={"button"}
        onClick={addPrincipal}
      >
        + Add one more Principal
      </div>
    </div>
  );
};

export default Principals;
